import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";

export default function Help() {
  return (
    <>
      <Sidebar openItem="tickets" activeItem="help" />

      <div className="content-wrapper">
        <TitleBar title="راهنما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body"></div>
          </div>
        </section>
      </div>
    </>
  );
}
